import * as types from '../mutation-types';

const state = () => ({
	stats: {}
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/stats').then(response => {
			commit(types.STORE_STATISTICS, response.data);
		});
	},
};

const mutations = {
	[types.STORE_STATISTICS](state, stats) {
		state.stats = stats;
	},
};

const getters = {
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};